import React from "react";

const Footer = props => (
  <footer className="footer">Copyright &copy; MyBlogger Inc.</footer>
);

export default Footer;
